import styles from './TimelineNode.module.css';

interface TimelineNodeProps {
  label: string;
  value: string;
}

export function TimelineNode({ label, value }: TimelineNodeProps) {
  return (
    <div className={styles.node}>
      <span className={styles.value}>{value}</span>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
